var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"form_button"}},[_c('div',{attrs:{"id":"form_button_button"},on:{"click":_vm.redirectForm}},[_vm._v(" 内見・入居のご相談 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }